module.exports = "/_next/static/images/circlestaralt-eb2cf36c78457e31ee970c76af358d1d.svg";